import { sendaDef, sendaOf, type CampaignState } from '@somnhold/sim';
import { t } from '../i18n.ts';

/**
 * The bastion's people know a hero who walked its path to the end (docs/SENDAS.md, «Qué pasa en el mundo»): Brann,
 * Hilde and Odna each say one line of their own the first time they see it after (`senda.<id>.met.<who>`), one per
 * visit to the bastion, one each and no more (this device remembers; a line never written is skipped).
 */

const WHO = ['brann', 'hilde', 'odna'] as const;
const NAME: Record<(typeof WHO)[number], string> = { brann: 'Brann', hilde: 'Hilde', odna: 'Odna' };

/** The next line to say for the hero playing here (said once, then remembered), or null. */
export const sendaGreeting = (s: CampaignState, me: string): string | null => {
  const p = s.players.find((x) => x.id === me);
  if (!p) return null;
  const def = sendaDef(p.hero);
  const st = sendaOf(p.hero);
  if (!def || !st || st.ch < def.chapters.length) return null;
  for (const who of WHO) {
    const key = `senda.${def.id}.met.${who}`;
    const text = t(key);
    if (text === key) continue;
    const seen = `somnhold.sendaMet.${s.id}.${p.id}.${who}`;
    try {
      if (localStorage.getItem(seen)) continue;
      localStorage.setItem(seen, '1');
    } catch {
      return null;
    }
    return `${NAME[who]}: «${text}»`;
  }
  return null;
};
